import React, { useCallback, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import styles from "./styles.module.css";
import StatusStrip from "../../components/StatusStrip";
import { WidgetItem } from "../../interfaces/TournamentsConfig";
import { StickyBtnBlock } from "./StickyBtnBlock";
import { Leaderboard } from "./Leaderboard";
import LeaderboardEmpty from "./LeaderboardEmpty";
import { useLeaderboardDetailsApi } from "../../api/useLeaderboardDetailsAPI";
import useQueryParams from "../../hooks/useQueryParams";
import { _isEmpty } from "../../utils/helpers/zupeeLodash";
import TopWinners from "./TopWinners";
import useRegisterTournament from "../../api/useRegisterTournament";
import Loader from "../../components/Loader";
import { LeaderboardData } from "../../interfaces/LeaderboardTypes";
import { useConfigStore } from "../../storage/configState";
import PromotionBanner from "../../components/PromotionBanner";
import { pushClevertapEvent } from "../../utils/analytics/clevertap";
import { CLEVERTAP_EVENTS } from "../../constant";

type LeaderboardTabProps = {
  tournament: WidgetItem;
  tournamentStatus: string;
  setTournamentCurrentStatus: () => void;
};

const LeaderboardTab: React.FC<LeaderboardTabProps> = ({
  tournament,
  tournamentStatus,
  setTournamentCurrentStatus,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const { gameName, ltid = 0 } = useQueryParams(["gameName", "ltid"]);
  const parsedLtid = Number(ltid);
  const [localNumRegistrations, setLocalNumRegistrations] = useState(
    tournament?.numRegistrations
  );
  let offsetToken = useRef<any>(null);
  const paramsData = {
    gameName: gameName ?? "ludonx",
    ltid: parsedLtid,
    ...(offsetToken?.current ? { offsetToken: offsetToken.current } : {}),
  };
  const {
    leaderboardConfig = {},
    isLoading = true,
    refetch,
  }: any = useLeaderboardDetailsApi(paramsData);
  const leaderboardData = leaderboardConfig?.data as LeaderboardData;
  // const leaderboardData = leaderboardDummyData?.data;
  const data = { gameName: "LUDONX", ltid: parsedLtid };
  const { registerTournament, loading } = useRegisterTournament(data);
  const { downloadScreenData } =
    useConfigStore.getState()?.homeScreenConfig || {};
  const bannerPath = downloadScreenData?.banner?.imageUrl || "";
  const bannerText = downloadScreenData?.banner?.bannerText || "";
  const ctaLink = downloadScreenData?.banner?.cta || {};

  // Clevertap Event
  const handleClickCTEventForRegisterTournament = useCallback(() => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_REGISTER_TOURNAMENT, {
      "location": "leaderboardTab",
    });
  }, []);

  const gamePlayActions = [
    {
      label: t("playAgain"),
      onClick: () => {
        window.alert("work in progress");
        // navigate(NAVIGATION_ROUTES.GAMEPLAY, { replace: true });
      },
      btnClass: "primaryBtn",
    },
  ];
  const Refetch = () => {
    refetch();
  };
  offsetToken.current = leaderboardData?.mainLeaderboard?.nextOffsetToken || "";
  if (loading) return <Loader transparent/>;

  return (
    <>
      <StatusStrip tournament={tournament} />
      <div className={clsx(styles.leaderboardDetailsContainer)}>
        {!_isEmpty(leaderboardData?.topWinners) && (
            <TopWinners data={leaderboardData} />
        )}
        {!_isEmpty(downloadScreenData) && (
          <PromotionBanner
            imageUrl={bannerPath}
            cta={ctaLink}
            bannerText={bannerText}
          />
        )}
        <StickyBtnBlock
          onClick={() => {
            registerTournament(true);
            handleClickCTEventForRegisterTournament();
            // setModalOpen(true);
          }}
          btnName={t("playAgain")}
          tournamentStatus={tournamentStatus}
          setTournamentCurrentStatus={setTournamentCurrentStatus}
          tournament={tournament}
        />
        {_isEmpty(leaderboardData?.mainLeaderboard?.items) &&
        _isEmpty(leaderboardData?.userPositions) ? (
          <LeaderboardEmpty
            PrizePooltext={tournament?.generalInfo?.prizePoolText}
            NumberofEntries={localNumRegistrations}
          />
        ) : (
          <>
            <Leaderboard
              data={leaderboardData}
              isLoading={isLoading}
              refetch={Refetch}
            />
          </>
        )}

        {/* <BottomSheetModal
          isOpen={isModalOpen}
          modalIcon={rupeeIcon}
          title={t("confirmPayment")}
          actions={gamePlayActions}
          onClose={() => setModalOpen(false)}
          content={
            <div className={clsx(styles.gameDetailsBox)}>
              <Accordion>
                <AccordionItem
                  title={
                    <div
                      className={clsx(
                        styles.entryBoxheading,
                        "fontSizeSm fontWeightMedium fontColorBlack"
                      )}
                    >
                      <span>{t("entryFee")}</span>
                      <span>{RUPEE_ICON + 10}</span>
                    </div>
                  }
                  backgroundColor="gray"
                  accordionInnerContentClassName={clsx(
                    styles.accordionInnerContent
                  )}
                >
                  hello
                </AccordionItem>
              </Accordion>
            </div>
          }
        /> */}
      </div>
    </>
  );
};
export default LeaderboardTab;
